export default __webpack_public_path__ + "static/media/eb-blk-banner-1.b46d97a9.jpg";